// Processor categories for Tender Documents
export const TENDER_PROCESSOR_CATEGORIES = {
    RISK: [
        { key: 'UNRESOLVED_ISSUES', translationKey: 'dashboard.conflict-title.UNRESOLVED_ISSUES' },
        { key: 'SITE_RISK', translationKey: 'dashboard.conflict-title.SITE_RISK' },
        { key: 'UNCLEAR_WORDING', translationKey: 'dashboard.conflict-title.UNCLEAR_WORDING' },
        { key: 'CONTRACT_RISK', translationKey: 'dashboard.conflict-title.CONTRACT_RISK' },
        {
            key: 'MISSING_REQUIREMENTS',
            translationKey: 'dashboard.conflict-title.MISSING_REQUIREMENTS',
        },
        { key: 'CONTRADICTIONS', translationKey: 'dashboard.conflict-title.CONTRADICTIONS' },
        { key: 'RESPONSIBILITY', translationKey: 'dashboard.conflict-title.RESPONSIBILITY' },
        { key: 'WITHDRAWN_STANDARD', translationKey: 'dashboard.conflict-title.WITHDRAWN_STANDARD' },
    ],
    INSIGHT: [
        { key: 'UNDEFINED_DEADLINES', translationKey: 'dashboard.conflict-title.UNDEFINED_DEADLINES' },
        {
            key: 'INTERNATIONAL_STANDARD_REFERENCE',
            translationKey: 'dashboard.conflict-title.INTERNATIONAL_STANDARD_REFERENCE',
        },
        { key: 'TIME_PERIODS', translationKey: 'dashboard.conflict-title.TIME_PERIODS' },
        { key: 'DEADLINES', translationKey: 'dashboard.conflict-title.DEADLINES' },
        { key: 'DOCUMENT_REFERENCES', translationKey: 'dashboard.conflict-title.DOCUMENT_REFERENCES' },
    ],
};
// Processor categories for Design Package Review
export const DPR_PROCESSOR_CATEGORIES = {
    RISK: [
        { key: 'UNCLEAR_WORDING', translationKey: 'dashboard.conflict-title.UNCLEAR_WORDING' },
        { key: 'CONTRADICTIONS', translationKey: 'dashboard.conflict-title.CONTRADICTIONS' },
        { key: 'WITHDRAWN_STANDARD', translationKey: 'dashboard.conflict-title.WITHDRAWN_STANDARD' },
    ],
    INSIGHT: [
        { key: 'MISSING_DRAWINGS', translationKey: 'dashboard.conflict-title.MISSING_DRAWINGS' },
        {
            key: 'MISSING_DRAWING_NAME_IN_INDEX',
            translationKey: 'dashboard.conflict-title.MISSING_DRAWING_NAME_IN_INDEX',
        },
        { key: 'MISSING_TITLE', translationKey: 'dashboard.conflict-title.MISSING_TITLE' },
        { key: 'MISSING_REVISION', translationKey: 'dashboard.conflict-title.MISSING_REVISION' },
        { key: 'MISSING_INFORMATION', translationKey: 'dashboard.conflict-title.MISSING_INFORMATION' },
        { key: 'MISSING_DETAIL', translationKey: 'dashboard.conflict-title.MISSING_DETAIL' },
        { key: 'MISSING_SCALE', translationKey: 'dashboard.conflict-title.MISSING_SCALE' },
        { key: 'MISSING_UNITS', translationKey: 'dashboard.conflict-title.MISSING_UNITS' },
        { key: 'SCALE_CITATION', translationKey: 'dashboard.conflict-title.SCALE_CITATION' },
        { key: 'UNIT_DISPARITY', translationKey: 'dashboard.conflict-title.UNIT_DISPARITY' },
    ],
};
// Processor categories for Bid Review (Offer). Reuses the tender RISK/INSIGHT
// sets and adds a GAPS category specific to comparing a bid against a tender.
export const OFFER_PROCESSOR_CATEGORIES = {
    RISK: TENDER_PROCESSOR_CATEGORIES.RISK,
    INSIGHT: TENDER_PROCESSOR_CATEGORIES.INSIGHT,
    GAPS: [
        {
            key: 'PARTIAL',
            translationKey: 'dashboard.conflict-title.PARTIAL',
        },
        {
            key: 'MISSING',
            translationKey: 'dashboard.conflict-title.MISSING',
        },
        {
            key: 'DEVIATION',
            translationKey: 'dashboard.conflict-title.DEVIATION',
        },
    ],
};
// Human-readable labels for conflict types (for use in UIs without i18n like backoffice)
export const CONFLICT_TYPE_LABELS = {
    UNRESOLVED_ISSUES: 'Unresolved Issues',
    SITE_RISK: 'Site Risk',
    UNCLEAR_WORDING: 'Unclear Wording',
    CONTRACT_RISK: 'Contract Risk',
    MISSING_REQUIREMENTS: 'Missing Requirements',
    CONTRADICTIONS: 'Contradictions',
    RESPONSIBILITY: 'Responsibility',
    WITHDRAWN_STANDARD: 'Withdrawn Standard',
    PROJECT_SCOPE_RISK: 'Project Scope Risk',
    UNDEFINED_DEADLINES: 'Undefined Deadlines',
    INTERNATIONAL_STANDARD_REFERENCE: 'International Standard Reference',
    TIME_PERIODS: 'Time Periods',
    DEADLINES: 'Deadlines',
    DOCUMENT_REFERENCES: 'Document References',
    PARTIAL: 'Partial',
    MISSING: 'Missing',
    DEVIATION: 'Deviation',
    ADDRESSED: 'Addressed',
};
